import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const searchLogs = createAsyncThunk(
    'document/logs',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentLog/search`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }        
            })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    loading: false,
    success: false,
    flag: false,
    loglist: [],
    errorDocumentNumber: '',
    message: '',
    error: ''
}

const documentLogSlice = createSlice({
    name: 'documentLog',
    initialState,
    reducers: {
    },
    extraReducers: {
        [searchLogs.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.flag = action.payload.status
            state.message = action.payload.message
            state.loglist = action.payload.data
        },
        [searchLogs.pending]: (state) => {
            state.loading = true
        },
        [searchLogs.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.flag = payload.status
            if(payload.response.data.error) {
                state.errorDocumentNumber = payload.response.data.error.documentNumber
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = documentLogSlice.actions;
export default documentLogSlice.reducer; 